(function () {
  var originalFetch = window.fetch;

  function refreshCartSections() {
    var cartItemsEl  = document.getElementById('main-cart-items');
    var cartFooterEl = document.getElementById('main-cart-footer');
    var sections = [];
    if (cartItemsEl)  sections.push(cartItemsEl.dataset.id);
    if (cartFooterEl) sections.push(cartFooterEl.dataset.id);
    if (sections.length === 0) return Promise.resolve();

    return originalFetch('/cart?sections=' + sections.join(','))
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var parser = new DOMParser();
        if (cartItemsEl && data[cartItemsEl.dataset.id]) {
          var doc = parser.parseFromString(data[cartItemsEl.dataset.id], 'text/html');
          var cur = cartItemsEl.querySelector('.js-contents');
          var nxt = doc.querySelector('.js-contents');
          if (cur && nxt) cur.innerHTML = nxt.innerHTML;
        }
        if (cartFooterEl && data[cartFooterEl.dataset.id]) {
          var doc2 = parser.parseFromString(data[cartFooterEl.dataset.id], 'text/html');
          var cur2 = cartFooterEl.querySelector('.js-contents');
          var nxt2 = doc2.querySelector('.js-contents');
          if (cur2 && nxt2) cur2.innerHTML = nxt2.innerHTML;
        }
      });
  }

  // 본품 삭제 시 크로스셀 자동 삭제: _requires_product가 카트에 없으면 해당 아이템 삭제
  function checkBundleRemoved(cart) {
    var cartProductIds = cart.items.map(function (i) { return String(i.product_id); });

    var toRemove = cart.items.filter(function (item) {
      var required = item.properties && item.properties['_requires_product'];
      return required && cartProductIds.indexOf(String(required)) === -1;
    });

    if (toRemove.length === 0) return;

    var updates = {};
    toRemove.forEach(function (item) { updates[item.key] = 0; });

    return originalFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function () {
      alert('The bundle discount item has been removed because the main product is no longer in your cart.');
      window.location.reload();
    });
  }

  // 업셀 버튼 클릭 → 카트 추가
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-upgrade]');
    if (!btn) return;

    btn.disabled = true;
    btn.querySelector('.cart-upsell-btn__text').hidden = true;
    btn.querySelector('.cart-upsell-btn__loading').hidden = false;

    var upsellRow = btn.closest('.cart-upsell-row');
    if (upsellRow) upsellRow.style.display = 'none';

    var addVariantId    = parseInt(btn.dataset.addVariant, 10);
    var requiresProduct = btn.dataset.requiresProduct || null;
    var body = { id: addVariantId, quantity: 1 };
    if (requiresProduct) {
      body.properties = { '_requires_product': requiresProduct };
    }

    originalFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function () { return refreshCartSections(); })
    .catch(function () { window.location.href = window.location.href; });
  });

  // fetch 인터셉트: 카트 변경 감지 (응답 JSON 바로 재사용, 추가 패치 없음)
  window.fetch = function (url, options) {
    var result = originalFetch.apply(this, arguments);
    if (typeof url === 'string' && url.indexOf('/cart/change') !== -1) {
      result.then(function (res) {
        return res.clone().json().then(checkBundleRemoved).catch(function () {
          // 프리뷰 환경 등 JSON 아닐 경우 폴백
          return originalFetch('/cart.js').then(function (r) { return r.json(); }).then(checkBundleRemoved);
        });
      });
    }
    return result;
  };

})();
